

































import { Component, Vue, Prop } from 'vue-property-decorator'
import TopMenu from './Components/TopMenu.vue'
import TableMenu from './Components/TableMenu.vue'
import Pagination from '@/app/ui/components/Pagination/index'
import { GuideCategoryDataModule } from '@/app/store/modules/guideCategory'
import { GalleryImageModule } from '@/app/store/modules/galleryImage'

@Component({
  components: {
    'top-menu': TopMenu,
    'table-menu': TableMenu,
    pagination: Pagination,
  },
})
export default class extends Vue {
  // Property Global
  private selected = []
  public get isLoading() {
    return GuideCategoryDataModule.isLoading
  }
  public get page() {
    return GuideCategoryDataModule.Pages
  }
  public get limit() {
    return GuideCategoryDataModule.Limit
  }
  public created() {
    this.getImage()
    this.getData()
  }
  public getImage() {
    GalleryImageModule.getGalleryImageData()
  }
  public getData() {
    GuideCategoryDataModule.getGuideCategoryData()
  }
  public get guideCategoryData() {
    return GuideCategoryDataModule.guideCategoryData
  }
  public get imageDataCategory() {
    return GalleryImageModule.galleryImageData
  }

  // Property Top Menu
  private searchInput = ''
  private funcSearch(item) {
    //  console.log('Panggil action get with query search', item)
  }

  public fields = [
    { key: 'no', sortable: false },
    { key: 'name', sortable: true },
    { key: 'totalFiles', sortable: false },
    { key: 'isActive', sortable: false },
    { key: 'updatedAt', sortable: false },
    { key: 'createdAt', sortable: false },
    { key: 'actions', sortable: false },
  ]

  // Property Pagination
  private onPageNumChanged(limit: any) {
    GuideCategoryDataModule.paginationParam.paging.limit = limit
    this.getData()
  }
  private funcFirstPage() {
    GuideCategoryDataModule.paginationParam.paging.page = 1
    this.getData()
  }

  private funcPrevPage() {
    GuideCategoryDataModule.paginationParam.paging.page =
      GuideCategoryDataModule.paginationParam.paging.page - 1
    this.getData()
  }
  private funcNextPage() {
    GuideCategoryDataModule.paginationParam.paging.page =
      GuideCategoryDataModule.paginationParam.paging.page + 1
    this.getData()
  }

  private funcLastPage() {
    GuideCategoryDataModule.paginationParam.paging.page =
      (this.guideCategoryData.pagination &&
        this.guideCategoryData.pagination.pageCount) ||
      0
    this.getData()
  }

  private onRowSelected(items) {
    this.selected = items
  }
  public clearTableStatus: boolean = false
  public clearRowSelected() {
    this.selected = []
    if (this.clearTableStatus === false) {
      this.clearTableStatus = true
    } else {
      this.clearTableStatus = false
    }
  }
}
